export { default as ZStack } from './component';